import type { RateOffsetLog } from 'graphql/gql-types';
import { twoDecimalRateFormatter } from 'pages/MyView/tableCustomCellRender';

export const transformData = (data: string[][]) => {
	const headers = data.map((row) => row[0]);
	const rows = data?.[0]
		?.slice(1)
		.map((_, colIndex) => {
			const row: Record<string, string> = {};
			headers.forEach((header, rowIndex) => {
				let rowData = data[rowIndex][colIndex + 1];
				if (header === 'date') rowData = renamePersonHeaders(rowData);
				row[header] = rowData;
			});
			return row;
		})
		.filter((row) => !!row);

	return { rows, headers };
};

const renamePersonHeaders = (header: string) => {
	const perPersonHeader = header.toLowerCase().split('per_');
	if (perPersonHeader?.length > 1) {
		return `${perPersonHeader[1]}${
			perPersonHeader[1].split('_')[1] ? '+' : ''
		} Person`;
	}
	return header;
};

export const convertArrObjToArrString = (
	data: Array<RateOffsetLog>,
): string[][] => {
	if (data?.length < 1) return [];
	const headers = Object.keys(data[0]).filter(
		(key) => key !== '__typename' && key !== 'rates' && key !== 'ratePlan',
	);

	const categories: Record<string, Set<string>> = {};

	for (const item of data) {
		for (const rate of item.rates) {
			if (!rate) continue;
			if (!categories[rate.category]) categories[rate.category] = new Set();
			for (const offset of Object.keys(rate.offsets).filter(
				(key) => key !== '__typename' && key !== 'ratePlan',
			)) {
				// @ts-ignore
				if (rate?.offsets[`${offset}`]) categories[rate.category].add(offset);
			}
		}
	}

	for (const [category, offsets] of Object.entries(categories)) {
		headers.push(category);
		for (const offset of offsets) {
			headers.push(offset);
		}
	}

	const transformData: string[][] = [headers];

	for (const item of data) {
		const row: Array<string> = [
			item.date,
			item.updatedAt || '',
			item.userId || '',
		];
		for (const [category, offsets] of Object.entries(categories)) {
			const rate = item.rates.find(
				(rate) => rate && rate.category === category,
			);
			row.push(''); // empty space for the category column
			for (const offset of offsets) {
				const offsetData =
					// @ts-ignore
					rate?.offsets && twoDecimalRateFormatter(rate.offsets[offset]);
				row.push(offsetData || '');
			}
		}
		transformData.push(row);
	}
	return transformData;
};
